<template>
  <div class="accordion">
    <!-- Desktop: horizontal tabs -->
    <div class="accordion__tabs max-md:hidden flex gap-30 border-b border-blue">
      <button
        v-for="(tab, index) in tabs"
        :key="`tab-${index}`"
        type="button"
        class="accordion__tab-btn relative -mb-[1px] pb-5 text-left font-degular text-base"
        :class="
          isTabOpen(index)
            ? 'border-b-2 border-blue text-blue font-bold'
            : 'text-blue hover:text-blue font-medium'
        "
        @click="toggleTab(index)"
      >
        {{ tab }}
      </button>
    </div>

    <div
      v-for="(tab, index) in tabs"
      v-show="isTabOpen(index)"
      :key="`panel-${index}`"
      class="accordion__content max-md:hidden py-20 text-base"
    >
      <slot :name="normalizeSlotName(tab)"></slot>
    </div>

    <!-- Mobile: stacked accordion with +/- icons -->
    <div class="accordion__mobile md:hidden flex flex-col">
      <div
        v-for="(tab, index) in tabs"
        :key="`mobile-${index}`"
        class="border-b border-blue"
      >
        <button
          type="button"
          class="accordion__mobile-header flex w-full items-center justify-between py-15 text-left font-degular text-base text-blue font-medium max-sm:py-10"
          :class="isMobileOpen(index) ? 'border-b border-blue !pb-0' : ''"
          @click="toggleMobile(index)"
        >
          <span :class="isMobileOpen(index) ? 'border-b-2 border-blue pb-10' : ''">{{ tab }}</span>
          <span class="accordion__mobile-icon flex-shrink-0 ml-10">
            <svg v-if="!isMobileOpen(index)" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M7 0L7 14" stroke="#0057C2"/>
              <path d="M14 7.17957L-3.27826e-07 7.17956" stroke="#0057C2"/>
            </svg>
            <svg v-else xmlns="http://www.w3.org/2000/svg" width="14" height="1" viewBox="0 0 14 1" fill="none">
              <path d="M14 0.500001L-3.27826e-07 0.5" stroke="#0057C2"/>
            </svg>
          </span>
        </button>
        <div v-show="isMobileOpen(index)" class="accordion__mobile-content pb-15 text-base max-sm:pt-10">
          <slot :name="normalizeSlotName(tab)"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Accordion",
  data() {
    return {openTabs: [0], openMobile: []};
  },
  props: {
    tabs: {type: Array, required: true},
  },
  methods: {
    toggleTab(index) {
      if (!this.openTabs.includes(index)) this.openTabs = [index];
    },
    isTabOpen(index) {
      return this.openTabs.includes(index);
    },
    toggleMobile(index) {
      this.openMobile = this.openMobile.includes(index) ? [] : [index];
    },
    isMobileOpen(index) {
      return this.openMobile.includes(index);
    },
    normalizeSlotName(name) {
      return name.replace(/\s+/g, "_").replace(/&/g, "and").toLowerCase();
    },
  },
};
</script>
